import { useQuery } from "@tanstack/react-query";
import { getEventDayHours } from "../services/eventDayHours.service";
import {
  dailyHoursApplicability,
  type DayHours,
  type DayHoursEvent,
} from "../utils/eventDayHours";

export const eventDayHoursKeys = {
  all: ["event-day-hours"] as const,
  forEvents: (ids: string[]) => [...eventDayHoursKeys.all, ids] as const,
};

/**
 * Daily-hours rows for the given events, fetched only for events that can have them (multi-day, timed), so a list
 * of single-day events costs no request. Display callers pass the map to resolveDailyHours().
 */
export function useEventDayHours(
  events: ReadonlyArray<(DayHoursEvent & { id: string }) | null | undefined>,
) {
  const ids = Array.from(
    new Set(
      events
        .filter(
          (e): e is DayHoursEvent & { id: string } =>
            !!e && dailyHoursApplicability(e).ok,
        )
        .map((e) => e.id),
    ),
  ).sort();
  return useQuery<Map<string, DayHours[]>>({
    queryKey: eventDayHoursKeys.forEvents(ids),
    queryFn: () => getEventDayHours(ids),
    enabled: ids.length > 0,
    staleTime: 60 * 1000,
    placeholderData: (prev) => prev,
  });
}
